import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { HandlebarsPipe } from '../../shared/pipes/templating/handlebars.pipe';
import { ContactComponent } from 'app/shared/components/contact/contact.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';
import { Themes } from 'themes';

@Component({
  selector: 'ez-completed',
  imports: [MainLayoutComponent, ContactComponent, HandlebarsPipe],
  providers: [CurrencyPipe],
  templateUrl: './completed.component.html',
  styleUrl: './completed.component.scss',
})
export class CompletedComponent implements OnInit {
  private route = inject(ActivatedRoute);

  protected readonly Themes = Themes;
  landingpageConfig: LandingpageConfiguration;

  ngOnInit(): void {
    this.route.data.subscribe({
      next: (data) => {
        this.landingpageConfig = data['landingPageConfiguration'];
      },
    });
  }
}
